import React from 'react';

const Skeleton = ({ className }: { className?: string }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} />
);

type ImageWithSkeletonProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  className?: string;
};

export function ImageWithSkeleton({
  src,
  alt,
  className,
  ...props
}: ImageWithSkeletonProps) {
  const [loaded, setLoaded] = React.useState(false);
  return (
    <div className={`relative overflow-hidden ${className ?? ''}`}>
      {!loaded && <Skeleton className="absolute inset-0 z-10" />}
      <img
        src={src}
        alt={alt}
        className={`${className ?? ''} ${loaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        onLoad={() => setLoaded(true)}
        {...props}
      />
    </div>
  );
}

export { Skeleton };
